// extracted by mini-css-extract-plugin
export var card = "_nk-0";
export var content = "_nk-2";
export var icon = "_nk-1";